export default __webpack_public_path__ + "static/media/MyTaskIcon.45c0413a.svg";